import {Button, Modal, notification, Progress} from "antd";
import {useEffect, useState} from "react";
import {APIs} from "../../constants/api.constants";
import {ApiService, postRequest} from "../../services/ApiService";

const chunkSize = 20 * 1024 * 1024; // 20 MB

export default function UploadVideo({ props }) {
  const [file, setFile] = useState(null);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);

  function readAndUploadCurrentChunk() {
    // reference repo: https://github.com/dejwid/mern-chunked-upload/
    if (!file || currentChunkIndex === null) {
      return;
    }
    const reader = new FileReader();
    const from = currentChunkIndex * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    reader.onload = e => uploadChunk(e);
    reader.readAsDataURL(blob);
  }

  function uploadChunk(readerEvent) {
    const data = readerEvent.target.result;
    const params = new URLSearchParams();
    params.set('name', file.name);
    params.set('size', file.size);
    params.set('currentChunkIndex', currentChunkIndex.toString());
    params.set('totalChunks', Math.ceil(file.size / chunkSize).toString());
    const payload = {
      chunkData: data
    }
    const url = `${APIs.uploadVideo}/${props.episodeData.data.id}?${params}`;
    ApiService.postRequest(url, payload)
        .then(response => {
          const filesize = file.size;
          const chunks = Math.ceil(filesize / chunkSize) - 1;
          const isLastChunk = currentChunkIndex === chunks;
          if (isLastChunk) {
            file.finalFilename = response.data.finalFilename;
            props.setPercentage(100);
            setTimeout(() => {
              props.setPercentage(0);
              props.setLoading(false);
              props.toggleVideoPopup();
            }, 3000);
            setCurrentChunkIndex(null);
          } else {
            setCurrentChunkIndex(currentChunkIndex + 1);
            props.setPercentage(Math.floor((currentChunkIndex/chunks) * 100));
          }
        })
        .catch(
          (error) => {
            notification['error']({message: error.message })
        });
  }

  useEffect(() => {
    if (currentChunkIndex !== null) {
      props.setLoading(true);
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);


  return <>
    <Modal
        visible={props.uploadVisibility}
        title="Upload Video"
        closable={false}
        onOk={() => {
          setCurrentChunkIndex(0); // this will initiate the upload
        }}
        footer={[
          <Button key="back"
                  onClick={props.toggleVideoPopup}>
            Return
          </Button>,
          <Button type="primary"
                  key="submit"
                  className={'btn btn-success'}
                  loading={props.loading}
                  onClick={() => {
                    setCurrentChunkIndex(0); // this will initiate the upload
                  }}>
            Submit
          </Button>
        ]}>

      {
        (!props.videoFile && props.currentVideoUrl) && <>
          <div className={`w-100percent mb-1`}>Current Video Url</div>
          <div className={`w-100percent mb-3`}>{props.currentVideoUrl}</div>
        </>
      }

      <div className={'w-100percent pt-1'}>
        <button onClick={props.handleClick}>
          Choose File
        </button>
        <span className='ml-2'>{props.videoFile?.name || 'No file chosen'}</span>
        <input type="file"
               id='fileUpload'
               name='filename'
               value=""
               hidden
               accept="video/mp4,video/x-m4v,video/*"
               onChange={(e) => {
                 setFile(e.target.files[0]);
                 props.setVideo(e.target.files[0]);
               }}/>
      </div>

      { (props.loading && (props.percentage !== 0)) &&
          <div className={'w-100percent p-2'}>
            <Progress percent={props.percentage}/>
          </div>
      }

      { (props.loading && props.textShowing) &&
          <label>Please Wait While Video is Finishing Up...</label>
      }
    </Modal>
  </>
}
